<template>
  <div class="type-selector type-selector__root">
    <div v-show="rootTypes.length > 0">
      <pui-common-select
        ref="select"
        :display="piivoTranslate"
        :label="showLabel ? $t('poster.type_selector.label') : null"
        :placeholder="placeholder"
        :options="rootTypes"
        :value="selectedType"
        :disabled="!rootTypes.length"
        :multiple="false"
        :taggable="false"
        :allowGrouping="true"
        :clearable="false"
        v-bind="$attrs"
        @select="changeType"
      />
    </div>
    <div v-show="rootTypes.length === 0" class="type-selector__validation-alert">
      <span>{{ $t('poster.type_selector.no_types.message') }}</span>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

import i18n from '../../../../core/i18n';

export default {
  name: 'puiTypeSelector',
  props: {
    /**
     * The root types from which to select
     */
    rootTypes: {
      type: Array,
      required: true,
    },
    /**
     * The current type
     */
    selectedType: {
      type: Object,
      default: null,
    },
    /**
     * If the label should be displayed
     */
    showLabel: {
      type: Boolean,
      default: true,
    },
    /**
     * Select placeholder
     */
    placeholder: {
      type: String,
      default: () => i18n.t('poster.type_selector.placeholder'),
    },
  },
  data() {
    return {};
  },
  methods: {
    piivoTranslate(value) {
      return Vue.filter('piivoTranslate')(value);
    },
    /**
     * Change type with selected type.
     * @param {Object} selectedType
     */
    changeType(selectedType) {
      selectedType = Array.isArray(selectedType)
        ? selectedType.length > 0
          ? selectedType[0]
          : null
        : selectedType;

      this.$emit('change', selectedType);
    },
    /**
     * Resets selection
     */
    resetSelection() {
      if (this.$refs.select && this.$refs.select.resetSelection) {
        return this.$refs.select.resetSelection();
      }
      return [];
    },
  },
};
</script>
